import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    Chip,
    Paper, Grid
} from "@material-ui/core";
import * as Yup from "yup";
import { BackButton } from "../../sc-utilities";
import { Autocomplete } from "@material-ui/lab";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

const DeviceCasePreselectionForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, activeCustomerID, onFetchDiagnoseCases } = props;

    const [diagnoseCases, setDiagnoseCases] = useState([]);

    const getDiagnoseCases = async (ProductType) => {
        const result = await onFetchDiagnoseCases({ ActiveCustomerID: activeCustomerID, q: { Visible: 1, ProductType } });
        if (result) {
            setDiagnoseCases(result);
        }
    };

    useEffect(() => {
        getDiagnoseCases(initialValues?.ProductType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, setFieldValue, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, setValues } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations['device_case_preselection_name'] || 'Device case pre-selection name'}
                                label={translations['device_case_preselection_name'] || 'Device case pre-selection name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl id="product_type" className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["choose_product_type"] || "Choose product type"}</InputLabel>
                                <Select
                                    name="ProductType"
                                    value={values.ProductType}
                                    onChange={(e) => { getDiagnoseCases(e.target.value); setValues({ ...values, ProductType: e.target.value, DiagnoseCases: [] }) }}
                                    onBlur={handleBlur}
                                    error={!!(errors.ProductType && touched.ProductType)}
                                    margin={"dense"}
                                    fullWidth={true}
                                >
                                    <MenuItem value={'mobile'}>
                                        {translations['mobile'] || 'Mobile'}
                                    </MenuItem>
                                    <MenuItem value={'work'}>
                                        {translations['work'] || 'Work'}
                                    </MenuItem>
                                    <MenuItem value={'watch'}>{translations['watch'] || 'Watch'}</MenuItem>
                                    <MenuItem value={'headphone'}>{translations['headphone'] || 'Headphone'}</MenuItem>
                                </Select>
                            </FormControl>
                            <Grid container direction="row" justify="center" alignItems="center" spacing={5}>
                                <Grid item xs={12} sm={10}>
                                    <Autocomplete
                                        name="DiagnoseCases"
                                        multiple
                                        id="diagnose_cases"
                                        aria-required={false}
                                        options={diagnoseCases}
                                        getOptionLabel={(option) => option.OriginalLongName || []}
                                        filterSelectedOptions
                                        getOptionSelected={(option, value) => option.DiagnoseCaseID === value.DiagnoseCaseID}
                                        value={values.DiagnoseCases || []}
                                        onChange={(_, value) => setFieldValue('DiagnoseCases', value)}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="standard" fullWidth={true} label={`${translations["choose_diagnose_cases"] || "Choose diagnose cases"}`} />
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip label={option.OriginalLongName} {...getTagProps({ index })} />
                                            ))
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    {values.DiagnoseCases?.length !== diagnoseCases?.length && <Button variant="contained" onClick={() => setFieldValue('DiagnoseCases', diagnoseCases)}>{translations["select_all"] || "Select all"}</Button>}
                                </Grid>
                            </Grid>
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        fullWidth={true}
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(DeviceCasePreselectionForm);
